import { BaseExportStrategy } from "./BaseExportStrategy";
import { IExportStrategyConfig } from "./types";

export class EcommerceExportStrategy extends BaseExportStrategy {
  getConfig(): IExportStrategyConfig {
    return {
      carriersEndpoint: "carriers_clients?getAll=true",
      ordersEndpoint: "orders",
      filesEndpoint: "/orders/files",
      summaryEndpoint: "/orders/summary",
      needsMerchants: false,
      needsAliases: true,
      needsMarketplaceId: true,
      needsClients: false,
    };
  }
}
